import dayjs from './dayjsHelper';

/* User's Roles */
const roleOptionsPaygreen = ['ADMIN', 'USER', 'PAYGREEN'];
const roleOptions = ['ADMIN', 'USER'];
const roleDefault = roleOptions.USER;

/* Offsets Status */
const statusOffsets = [
    'CREATED',
    'ONGOING',
    'CLOSED',
    'PURCHASED',
    'OFFSET_FROM_ANOTHER_VENDOR',
    'CONTRIBUTED',
    'USER_CONTRIBUTED',
];

/* Matching Status */
const statusMatching = ['MONETARY', 'EQUIVALENCE', 'NO_MATCH'];

/* Dates */
const startOfMonth = dayjs().startOf('month').format('DD/MM/YYYY');
const endOfMonth = dayjs().endOf('month').format('DD/MM/YYYY');

/* Carbon Modes */
const carbonModes = { carbon: 'carbon', price: 'price' };

/* Matching CMS add product modes */
const addProductModes = {
    manual: 'manual',
    csv: 'csv',
    cms: 'cms',
};

/* Action product modes */
const actionProductModes = {
    delete: 'delete',
    match: 'match',
};

/* All locale fr languages available in browsers */
const frLangLocale = [
    'fr-FR',
    ['fr'],
    'fr',
    'fr-BE',
    'fr-CA',
    'fr-CH',
    'fr-LU',
    'fr-MC',
];

/* Products categories values that are "valid" because they contain product references */
const validProductCategories = [
    'fashion',
    'hotel',
    'meat',
    'fish',
    'grocery',
    'greens',
    'tech',
];

/* Login account error message modes */
const accountErrorModes = {
    notRegistered: 'notRegistered',
    notValidated: 'notValidated',
};

/* Login local status messages type */
const localLoginStatus = {
    success: 'success',
    warning: 'warning',
};

/* Sepa user Status */
const statusSepa = ['SIGNED', 'NOTSIGNED'];

/* Account user Status */
const statusActivation = ['CREATED', 'VALIDATED'];

/* Billing messages modes depending on environment and billing status */
const billingDisplayModes = {
    adress: 'adress',
    iban: 'iban',
};

/* Contributions Status */
const statusContributions = [
    'TO_WITHDRAW',
    'REFUND',
    'CANCELLED',
    'RESERVED',
    'WITHDREW',
];

const MODES = {
    TEST: 'test',
    PROD: 'prod',
};

/* Spaces available */
const spaces = {
    charity: 'charity',
    climate: 'climate',
};

const maxProject = 6;

export {
    statusOffsets,
    roleOptions,
    roleOptionsPaygreen,
    roleDefault,
    startOfMonth,
    endOfMonth,
    carbonModes,
    statusMatching,
    addProductModes,
    frLangLocale,
    validProductCategories,
    accountErrorModes,
    statusSepa,
    statusActivation,
    billingDisplayModes,
    statusContributions,
    MODES,
    spaces,
    localLoginStatus,
    actionProductModes,
    maxProject,
};
